<template>
    <article class="appointment_list">
      <div ref="header">
        <search-input v-model="queryForm.plate_number" placeholder-word="请输入车牌号码" @on-search="searchData" @on-enter="searchData" @input="handleSearchContent"></search-input>
        <tab-list
          v-if="queryForm.time === 'today'"
          :tab-list="tabList"
          :status.sync="queryForm.tab"
          @tab-change="searchData">
        </tab-list>
      </div>
      <scroller
        lock-x scrollbar-y
        use-pullup
        ref='myScroller'
        :height="scrollerHeight"
        @on-pullup-loading="loadMore"
        :pullup-config="pullConfig"
        v-if="totalCount"
        >
        <div class="appointment_items">
          <group v-for="(item, index) in bookings" :key="index">
            <cell :title="`预约号：${item.id}`" class="appointment_status">
              <span slot="value" class="status_txt">{{item.status | formateStatus}}</span>
            </cell>
            <cell :bdStart="true" class="appointment_service" @click.native="getDetail(item.id)">
              <p slot="after-title" class="appointment_title">{{item.plate_number || item.vin || '--'}}</p>
              <template v-if="queryForm.time === 'today'">
                <p slot="after-title" class="appointment_time">客户姓名：{{item.contact_name}}</p>
                <p slot="after-title" class="appointment_time">预约时间：{{item.appointed_time}}</p>
                <p slot="after-title" class="appointment_time">服务项目：{{item.services.map(item => item.name).join('、')}}</p>
                <p slot="after-title" class="appointment_time">服务顾问：{{(item.receiver && item.receiver.name) || '--'}}</p>
                <p slot="after-title" class="appointment_time">跟进人：{{item.service_consultant.name}}</p>
                <p slot="after-title" class="appointment_time">来源渠道：{{item.channel.name}}</p>
                <p slot="after-title" class="appointment_time">备注信息：{{item.remark || '--'}}</p>
              </template>
              <template v-else>
                <p slot="after-title" class="appointment_time">联系人：{{item.contact_name}}</p>
                <p slot="after-title" class="appointment_time">到店时间：{{item.appointed_time}}</p>
                <p slot="after-title" class="appointment_time">服务项目：{{item.services.map(item => item.name).join('、')}}</p>
                <p slot="after-title" class="appointment_time">来源渠道：{{item.channel.name}}</p>
                <p slot="after-title" class="appointment_time">跟进人：{{item.service_consultant.name}}</p>
                <p slot="after-title" class="appointment_time">备注：{{item.remark || '--'}}</p>
                <!--<p slot="after-title" class="appointment_time">提交时间：{{item.created_at}}</p>-->
              </template>
            </cell>
            <cell class="operate_btn">
              <!--<x-button mini plain type="primary" @click="operate('cancel',item.id, index)">未到店</x-button>-->
              <!--<x-button mini plain type="primary" @click="operate('fulfill',item.id, index)" v-if="item.is_confirmed">已到店</x-button>-->
              <!--<x-button mini plain type="primary" @click="operate('confirm',item.id, index)" v-else>确认预约</x-button>-->
              <x-button
                v-for="btn in btns[item.support_ops]" :key="btn.text"
                mini
                plain
                type="primary"
                @click="btn.operation(item.id, index)"
              >{{ btn.text }}</x-button>
            </cell>
          </group>
          <p class="tip-text1 tip-bottom">共{{totalCount}}条记录</p>
        </div>
      </scroller>
      <no-car v-else></no-car>
      <section class="btn-bottom" v-if="showAddNewBtn">
        <div class="btn-fix">
          <a class="btn" v-if="isBookingAdd" @click.stop="handleCreateNew(queryForm.plate_number)">新增预约</a>
        </div>
      </section>
      <!--取消预约弹窗-->
      <SendMsgPopup
        title="请输入取消原因"
        v-model="cancelVisible"
        :cb="cancelCb"
      />
      <!-- 已到店弹窗 -->
      <BizOptInStorePopup
        ref="bizOptInStorePopupRef"
        :changeStatus="changeStatus"
      />
    </article>
</template>

<script>
import { Group, Cell, XButton, Scroller } from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'
import BizOptInStorePopup from './features/BizOptInStorePopup.vue'
import SendMsgPopup from './SendMsgPopup'
import NoCar from '../components/NoCar'
import TabList from '../components/TabList'
import util from '../../common/util'

export default {
  components: {
    SearchInput,
    Group,
    Cell,
    XButton,
    NoCar,
    TabList,
    Scroller,
    BizOptInStorePopup,
    SendMsgPopup
  },
  data () {
    return {
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      tabList: [
        { key: 1, name: '全部' },
        { key: 2, name: '已到店' },
        { key: 3, name: '待到店' },
        { key: 4, name: '超时未到' }
      ],
      queryForm: {
        page: 1,
        count: 10,
        plate_number: '',
        time: 'all', // 时间范围 all 表示全部 / today 表示今日 默认为全部
        tab: 1, // 今日预约页面 tab 标签
        is_confirmed: '' // 筛选是否确认的预约 true 已经确认 / false 未确认 为空时表示不筛选 注意类型为string
      },
      totalCount: 0,
      totalPage: 0,
      bookings: [],
      cancelVisible: false, // 取消弹窗
      currentId: '', // 当前正在操作的订单ID， 操作某一项时需要更新该值
      currentIndex: 0,
      showAddNewBtn: false,
      scrollerHeight: '',
      isBookingAdd: false
    }
  },
  async created() {
    const change = {
      text: '更改预约',
      operation: this.doChange
    }
    const cancel = {
      text: '取消预约',
      operation: this.doCancel
    }
    const overTime = {
      text: '超时处理',
      operation: this.doOverTime
    }
    const inStore = {
      text: '已到店',
      operation: this.doInStore
    }
    const confirm = {
      text: '确认预约',
      operation: this.doConfirm
    }
    const arrivalAuth = await this.hasAuth('service_booking.modify_customer_enter_status')
    this.btns = {
      finished: [],
      unconfirmed: [
        change,
        confirm
      ],
      unfulfilled: arrivalAuth ? [
        inStore,
        change,
        cancel
      ] : [
        change,
        cancel
      ],
      unfulfilled_today: arrivalAuth ? [inStore, change] : [change],
      unfulfilled_over_appointed: [ overTime ]
    }
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    let isConfirmed = this.$route.params.isConfirmed
    let path = this.$route.path
    if (isConfirmed) this.queryForm.is_confirmed = isConfirmed // 待确认
    if (path.endsWith('today')) this.queryForm.time = 'today' // 近日到店
    this.getData()
  },
  filters: {
    formateStatus(statusCode) {
      const statusTxt = {
        'unknown': '未知',
        'pending_fulfillment': '待到店',
        'pending_confirm': '待确认',
        'before_fulfilled': '提前到店',
        'fulfilled': '已到店',
        'after_fulfilled': '超时到店',
        'canceled': '已取消',
        'unfulfilled': '未到店'
      }
      return statusTxt[statusCode] || '--'
    },
    formateTime(time) {
      return util.formatTime(time, 'yyyy-MM-dd hh:mm')
    }
  },
  methods: {
    hasAuth(auth) {
      return this.$store.state.promiseAuth.then(data => data.authList.includes(auth))
    },
    handleSearchContent(val) {
      if (val === '') {
        this.getData()
      }
    },
    async searchData() {
      this.queryForm.page = 1
      await this.getData()
      this.showAddNewBtn = true
    },
    async cancelCb(msg) { // 取消回调
      await this.changeStatus({ action: 'cancel', reason: msg })
    },
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.appointment.getAppointmentList(this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.totalCount = data.total_count
          this.bookings = data.bookings
          this.isBookingAdd = data.is_booking_add === 1
          this.totalPage = parseInt((this.totalCount + count - 1) / count)
          const otherCount = data.other_count
          this.tabList = [
            { key: 1, name: `全部(${otherCount.all})` },
            { key: 2, name: `已到店(${otherCount.fulfilled})` },
            { key: 3, name: `待到店(${otherCount.pending_fulfillment})` },
            { key: 4, name: `超时未到(${otherCount.unfulfilled})` }
          ]
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        this.queryForm.page++
        this.$rest.appointment.getAppointmentList(this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalCount = data.total_count
            this.totalPage = parseInt((this.totalCount + count - 1) / count)
            this.bookings.push(...data.bookings)
            const otherCount = data.other_count
            this.tabList = [
              { key: 1, name: `全部(${otherCount.all})` },
              { key: 2, name: `已到店(${otherCount.fulfilled})` },
              { key: 3, name: `待到店(${otherCount.pending_fulfillment})` },
              { key: 4, name: `超时未到(${otherCount.unfulfilled})` }
            ]
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    getDetail(id) {
      this.$router.push({
        path: `/appointment/detail/${id}`
      })
    },
    operate (status, id, index) {
      this.$rest.appointment.updateAppointmentStatus({
        action: status
      }, `${id}/status`).then((res) => {
        if (res.code === 0) {
          let data = res.data
          this.bookings[index].status = data.status
          this.bookings[index].is_confirmed = data.is_confirmed
        } else {
          this.showToast(res.message)
        }
      })
    },
    resetPopup() {
      this.cancelVisible = false
    },
    // 超时处理, 取消预约, 已到店, 确认预约 通用处理方法（还包括更改预约时间的操作）
    async changeStatus(params, api = 'updateAppointmentStatus') {
      this.loading = true
      try {
        const { code, message } = await this.$rest.appointment[api](this.currentId)(params)
        if (code === 0) {
          // 这种直接修改数据的方式也许会不刷新
          // this.bookings[this.currentIndex].status = data.status
          // data.support_ops && (this.bookings[this.currentIndex].support_ops = data.support_ops)
          // data.appointed_time && (this.bookings[this.currentIndex].appointed_time = data.appointed_time)
          this.queryForm = {
            ...this.queryForm,
            page: 1,
            count: 10
          }
          this.resetPopup()
          this.getData()
        } else {
          this.showToast(message)
        }
      } catch (e) {
        this.showToast(e.message)
        throw e
      } finally {
        this.loading = false
      }
    },
    updateIdAndIndex(id, order) {
      this.currentId = id
      this.currentIndex = order
    },
    // 更改预约
    doChange(id) {
      this.$router.push(`/appointment/updateOrder/${id}`)
    },
    doCancel() {
      this.updateIdAndIndex(...arguments)
      this.cancelVisible = true
    },
    doOverTime(id) {
      this.$router.push(`/appointment/OverTimeConfirm/${id}`)
    },
    doInStore() {
      this.updateIdAndIndex(...arguments)
      this.$refs.bizOptInStorePopupRef.open()
      // this.changeStatus({ action: 'fulfill', fulfill_type: 1 })
    },
    doConfirm() {
      this.updateIdAndIndex(...arguments)
      this.changeStatus({ action: 'confirm' })
    },
    handleCreateNew(plateNum) {
      this.$router.push({ path: '/appointment/newAppointment', query: { plate_number: plateNum } })
    }
  }
}
</script>

<style lang="less">
@import "../../stylesheets/modules/appointment/list.less";
</style>
